import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

// Lands here after an OAuth sign-in: the API redirects to /auth/callback#token=sess_…. We read the
// token from the URL FRAGMENT (never sent to a server / logged), adopt the session, and clear it.
export function AuthCallbackPage() {
  const { adoptSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get('token');
    // Strip the token from the address bar immediately.
    window.history.replaceState(null, '', window.location.pathname);
    if (!token) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }
    adoptSession(token)
      .then(() => navigate('/', { replace: true }))
      .catch(() => navigate('/login?error=oauth_failed', { replace: true }));
  }, [adoptSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper text-slate-400">
      <span className="flex items-center gap-3 text-sm">
        <Loader2 className="h-5 w-5 animate-spin text-ink" /> Signing you in…
      </span>
    </div>
  );
}
